<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <img src="/assets/iconography/parent-child-properties.svg" />
    <h3 fxFlex class="nomargin">Related properties</h3>
    <sbnb-button type="secondary" size="mini" [loading]="deleting" (clicked)="removeRelationship()">
      Remove relationship
    </sbnb-button>
  </div>

  <ng-container *ngIf="loading">
    <mat-spinner diameter="16"></mat-spinner>
  </ng-container>

  <ng-container *ngIf="!loading">
    <div class="review-headings" fxLayout fxLayoutGap="24px">
      <div fxFlex>Property name</div>
      <div fxFlex="80px">Relationship</div>
      <div fxFlex>Behavior</div>
    </div>

    <div
      *ngFor="let property of parentChildConfig.properties; let i = index; let last = last"
      class="review-property"
      [class.parent]="i === 0"
      [class.last]="last"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="24px">
      <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <img *ngIf="i === 0" fxHide.lt-md [src]="property.picture" class="property-thumb" />

        <div *ngIf="i !== 0" fxHide.lt-md class="child-arrow">
          <div class="child-arrow-vertical"></div>
          <div class="child-arrow-horizontal"></div>
          <div class="child-arrow-head"></div>
        </div>

        <a
          class="hover:underline"
          [routerLink]="['/properties/property', property.id]">
          {{ property.name }}
        </a>
      </div>

      <div fxFlex="80px" class="badge" [class.badge-parent]="i === 0">{{ i === 0 ? 'Parent' : 'Child' }}</div>

      <div fxFlex class="text__small">
        <span *ngIf="i === 0">A booking at this property will block all children property calendars.</span>
        <span *ngIf="i !== 0 && parentChildConfig.configuration === 'none-blocking'">
          A booking at this property will block the parent property's calendar.
        </span>
        <span *ngIf="i !== 0 && parentChildConfig.configuration === 'blocking'">
          A booking at this property will block the parent property's calendar, and all child property's calendars.
        </span>
      </div>
    </div>
  </ng-container>
</div>
